/* import __COLOCATED_TEMPLATE__ from './navigation-container-item.hbs'; */
import Component from '@glimmer/component';

export default class NavigationContainerItem extends Component {}
